import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { CostCenterStateClass } from './interfaces/costCenterStateClass';
import { sortData } from '../../../common/timeLiveFunction';
const initialState: CostCenterStateClass = {
    isLoading: false,
    status: 'idle',
    costCenterList: [],
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'AccountCostCenter',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        costCenter: CostCenterStateClass;
    },
}
export const getAccountCostCenterAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'costCenter/getAccountCostCenter',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/CostCenter', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const getAccountCostCenterByIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'costCenter/getAccountCostCenterById',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/CostCenter/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const addCostCenterAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'costCenter/addCostCenter',
        async (arg, thunkApi) => {

            const response = await fetchAPI('api/v2/CostCenter/', 'POST', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const UpdateCostCenterAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'costCenter/UpdateCostCenter',
        async (arg, thunkApi) => {
            const { AccountCostCenterId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/CostCenter/' + AccountCostCenterId, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deleteCostCenterAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'costCenter/deleteCostCenter',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/CostCenter/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
export const deleteAllSelectedRecordCostCenterAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "paymentMethod/DeleteAllSelectedRecordCostCenter",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/CostCenter/DeleteAllSelectedRecordCostCenter/', 'DELETE', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;

        }
    )
export const costCenterSlice = createSlice({
    name: 'costCenter',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.costCenterList.findIndex((item) => item.AccountCostCenterId == action.payload);
            const newArray = [...state.costCenterList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.costCenterList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.costCenterList.findIndex((item) => item.AccountCostCenterId == action.payload);
            const newArray = [...state.costCenterList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.costCenterList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.costCenterList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.costCenterList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.costCenterList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.costCenterList = newArray;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.costCenterList;
            state.costCenterList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountCostCenterAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountCostCenterAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.costCenterList = [];
                } else {
                    state.costCenterList = payload.Data;
                    state.costCenterList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
                state.isLoading = false;

            })
            .addCase(getAccountCostCenterAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(getAccountCostCenterByIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountCostCenterByIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.selectedRecord = {};
                } else {
                    state.selectedRecord = payload.Data[0];
                }
                state.isLoading = false;

            })
            .addCase(getAccountCostCenterByIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(addCostCenterAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addCostCenterAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addCostCenterAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(UpdateCostCenterAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(UpdateCostCenterAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(UpdateCostCenterAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(deleteCostCenterAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
                state.isLoading = true;


            })
            .addCase(deleteCostCenterAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteCostCenterAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(deleteAllSelectedRecordCostCenterAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAllSelectedRecordCostCenterAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAllSelectedRecordCostCenterAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
    }
})
export const {
    resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, updatePagination,updateSorting
} = costCenterSlice.actions
export const costCenterStateClass = (state: RootState) => state.costCenter
export default costCenterSlice.reducer